import React, { useState, useEffect } from "react"
import axios from "axios"
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder"
import ListSubheader from "@mui/material/ListSubheader"
import List from "@mui/material/List"
import ArchivoArea from "./ArchivoArea"
import { CircularProgress, Stack } from '@mui/material';

import { URL_API_SIA } from "../Contantes/Constantes"

export default function ArchivoListas() {
  const axiosInstance = setupInterceptorsTo(axios.create())
  const [loadingArchivos, setloadingArchivos] = useState(true)
  const [archivos, setArchivos] = useState([])

  useEffect(() => {
    setloadingArchivos(true)
    axiosInstance({
      method: "GET",
      url: `${URL_API_SIA}/sec_administrativa`,
    })
      .then((response) => {
        setArchivos(response.data)
        setloadingArchivos(false)
      })
      .catch((e) => {
        console.error(e)
        setloadingArchivos(false)
      })
  }, [])

  return (
    <List
      sx={{
        width: "100%",
        bgcolor: "background.paper",
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      {loadingArchivos ? (
        <Stack justifyContent={"center"} alignItems={"center"}>
          <CircularProgress />
        </Stack>
      ) : (
        archivos.map((area, areaIndex) => (
          <ArchivoArea areaIndex={areaIndex} area={area} />
        ))
      )}
    </List>
  )
}
